import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" onClick={toTop} className="logo-link">
            <span className="brand-mark" aria-label="camartzuno">
              <span className="brand-mark__c">C</span>
              <span className="brand-mark__word">AMARTZUNO</span>
            </span>
          </Link>
        </div>
        <nav className="header-nav">
          <Link to="/shop" onClick={toTop}>
            SHOP
          </Link>

          <Link to="/about" onClick={toTop}>
            OUR STORY
          </Link>
          <Link to="/contact" onClick={toTop}>
            CONTACT
          </Link>
          <div className="more-menu">
            <button type="button" onClick={() => setMoreOpen((open) => !open)} aria-expanded={moreOpen}>
              MORE <span aria-hidden="true">⌄</span>
            </button>
            {moreOpen && (
              <div className="more-menu__panel">
                <Link to="/policies" onClick={() => { setMoreOpen(false); toTop(); }}>All Policies</Link>
                <Link to="/privacy" onClick={() => { setMoreOpen(false); toTop(); }}>Privacy Policy</Link>
                <Link to="/cookies" onClick={() => { setMoreOpen(false); toTop(); }}>Cookie Policy</Link>
                <Link to="/faqs" onClick={() => { setMoreOpen(false); toTop(); }}>FAQs</Link>
                <Link to="/terms" onClick={() => { setMoreOpen(false); toTop(); }}>Terms</Link>
                <Link to="/shipping" onClick={() => { setMoreOpen(false); toTop(); }}>Shipping</Link>
                <Link to="/returns" onClick={() => { setMoreOpen(false); toTop(); }}>Refunds</Link>
              </div>
            )}
          </div>
        </nav>
        <div className="header-right">
          <Link
            to="/cartpage"
            className="icon-wrapper cart-icon"
            onClick={toTop}
          >
            <svg
              aria-hidden="true"
              focusable="false"
              role="presentation"
              className="icon icon-bold-cart"
              viewBox="0 0 30 30"
              width={20}
              height={20}
            >
              <path d="M2.932 4.007a1.689 1.689 0 00-1.41 1.932 1.699 1.699 0 001.947 1.4h5.037l.302.833 1.377 4.165 1.376 4.166c.135.433.705.833 1.142.833h11.752c.47 0 1.007-.4 1.142-.833l2.72-8.331c.134-.433-.068-.833-.538-.833H12.871l-1.276-2.4a1.68 1.68 0 00-1.478-.932H3.402a1.692 1.692 0 00-.302 0 1.692 1.692 0 00-.202 0h.034zm10.61 16.66c-.94 0-1.679.734-1.679 1.667S12.603 24 13.543 24s1.678-.733 1.678-1.666c0-.933-.739-1.666-1.679-1.666zm10.073 0c-.94 0-1.678.734-1.678 1.667S22.675 24 23.615 24s1.68-.733 1.68-1.666c0-.933-.74-1.666-1.68-1.666z" />
            </svg>

            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
